var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../shared/nunjucks.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("D:/Cloud/cloudmine-panel-core/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/dashboard-grouped-metrics.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<h1 class=\"page-header\">Metrics <small>by ";
output += runtime.suppressValue(env.getFilter("pretty").call(context, "poo"), env.opts.autoescape);
output += "</small></h1>\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "groupBy")),"length") > 1) {
output += "<ul id=\"filters-tabs\" class=\"nav nav-pills\">\n    ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "groupBy");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("f", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "<li role=\"navigation\" data-filter=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"filter"), env.opts.autoescape);
output += "\">\n        <a href=\"#\" data-filter=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"filter"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("pretty").call(context, runtime.memberLookup((t_4),"title")), env.opts.autoescape);
output += "</a></li>";
;
}
}
frame = frame.pop();
output += "\n</ul>";
;
}
output += "\n<div id=\"metrics\"></div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/dashboard-grouped-metrics.html"] , dependencies)